import clsx from "clsx";
import { graphql } from "gatsby";
import React, { FC } from "react";

import { CompanyEvent } from "../../company-event";
import { Container } from "../../container";

export interface CompanyCalendarProps extends Queries.CompanyCalendarDataFragment {}

export const CompanyCalendar: FC<CompanyCalendarProps> = ({
  title,
  description,
  companyEvents,
}) => {
  return (
    <Container className="pb-20 bg-neutral" pagePaddingX>
      <div className={clsx({ "pt-20": title || description })}>
        {title && <h2 className="text-primary font-medium text-3xl md:text-4xl mb-4">{title}</h2>}
        {description?.text && <p className="text-md md:text-lg font-light">{description.text}</p>}
      </div>
      <div className="flex flex-col gap-3 mt-8">
        {companyEvents?.map((eventProps, index) => <CompanyEvent key={index} {...eventProps!} />)}
      </div>
    </Container>
  );
};

export const query = graphql`
  fragment CompanyCalendarData on ContentfulCompanyCalendar {
    title
    description {
      text: description
    }
    companyEvents {
      ...CompanyEventData
    }
  }
`;
